import React, { useEffect } from "react";
import queryString from "query-string";

// services
import { api_GET } from "../../services/api_service.js";
import { showMessage } from "../../services/message.js";

// views — reutiliza a ficha já existente, sem duplicar a tela
import FichaGerador from "../Shared/Gerador/FichaGerador";

//Context
import { useAuth } from "../../context/auth.js";

/**
 * Abertura direta da ficha cadastral (ficha do protocolo) do gerador em nova guia,
 * usada pelo botão "Acessar ficha cadastral" da análise do requerimento.
 */
export default function FichaCadastral({ history }) {
  const { setLoading } = useAuth();

  const [protocolo, set_protocolo] = React.useState(null);

  const loadProtocolo = () => {
    const params = queryString.parse(history.location.search);

    if (params.protocolo == null) {
      showMessage("Aviso", "Cadastro não informado!", "error", null);
      return;
    }

    setLoading(true);
    api_GET("Protocolo/ByNumeroProtocolo/" + encodeURIComponent(params.protocolo))
      .then((result) => set_protocolo(result.data))
      .catch((err) => showMessage("Aviso", err.message, "error", null))
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    loadProtocolo();
  }, []);

  return (
    <>
      <div className="content">
        {protocolo != null && (
          <FichaGerador
            item={protocolo}
            history={history}
            showAcoesGestor={true}
          />
        )}
      </div>
    </>
  );
}
